import { Flex } from "@chakra-ui/layout";
import { ContaPassivelDeAdicaoAoRateio } from "../typings";
import { Text } from "@chakra-ui/react";
import { formatMoney } from "infra/helpers/number";
import moment from "moment";
import { useMemo } from "react";

function useContasRateioColumns() {
  return useMemo(() => {
    return [
      {
        title: "Data",
        width: "150px",
        render: (original: ContaPassivelDeAdicaoAoRateio) => (
          <Text lineHeight={"20px"} fontSize={14}>
            {moment(original.dataVencimento).format("DD/MM/YYYY")}
          </Text>
        ),
      },
      {
        title: "Descrição",
        render: (original: ContaPassivelDeAdicaoAoRateio) => (
          <Text lineHeight={"20px"} fontSize={14}>
            {original.descricao}
          </Text>
        ),
      },
      // {
      //   title: "Categoria",
      //   render: (original: ContaPassivelDeAdicaoAoRateio) => (
      //     <Text fontSize={14} lineHeight={"18px"}>
      //       <Flex flex={1}> {original.categoria} </Flex>
      //     </Text>
      //   ),
      // },
      {
        title: () => <Flex display="inline">Valor</Flex>,
        render: (original: ContaPassivelDeAdicaoAoRateio) => (
          <Text lineHeight={"20px"} fontSize={14}>
            {original.valor ? formatMoney(original.valor) : "--"}
          </Text>
        ),
      },
    ];
  }, []);
}

export default useContasRateioColumns;
